import DashboardPageLayout from "../pages/dashboard/DashboardPageLayout";
import HomePage from "../pages/home/HomePage";
import { RouteType } from "./config";
import DefaultPage from "../pages/dashboard/DefaultPage";
import DashboardIndex from "../pages/dashboard/DashboardIndex";
import CreateCampaign from "../pages/dashboard/CreateCampaign";
import ConversionsUpload from "../pages/dashboard/ConversionPage";
import ComponentPageLayout from "../pages/component/ComponentPageLayout";
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';

import DailyActivityPage from "../pages/component/DailyActivity";
import SummaryPage from "../pages/component/Summary";
import InboxPage from "../pages/installation/InstallationPage";
import Bidlog from "../pages/dashboard/Bidlog";
import ManagepostbackPage from '../pages/globalpostback/Managepostback';
import AdminPage from '../pages/dashboard/Adminpage';
import Multisteppage from '../pages/globalpostback/Multisteppage';
import GlobalPostbackPage from "../pages/globalpostback/Globalpostback";
import AnalyticsPage from "../pages/component/Analytics";
import TestPostbackPage from "../pages/globalpostback/Testpostback";
import ErrorLogPage from "../pages/globalpostback/Errorlog";
import FundingandpaymentPage from "../pages/Fundingandpayment/Fundingandpayment";
import AddFundsPage from "../pages/Fundingandpayment/AddFund";
import AutomaticFundingPage from "../pages/Fundingandpayment/AutomaticFunding";
import ProformaInvoicePage from "../pages/Fundingandpayment/ProformaInvoice";
import TransactionHistoryPage from "../pages/Fundingandpayment/TransactionHistory";
import MonthlyInvoicesPage from "../pages/Fundingandpayment/MonthlyInvoices";
import TrafficEstimatorPage from "../pages/Trafficestimator/TrafficEstimator";
import ManageAccountPage from "../pages/manageaccount/ManageAccount";
import EditprofilePage from "../pages/manageaccount/EditProfile";
import ChangePasswordPage from "../pages/manageaccount/ChangePassword";
import TwoFactorAuthPage from "../pages/manageaccount/TwoFactorAuth";
import DomianBlacklistPage from "../pages/manageaccount/DomianBlacklist";
import IpblackListPage from "../pages/manageaccount/IpblackList";
import UserAgentBlacklistPage from "../pages/manageaccount/UserAgentBlacklist";
import ApiAccessPage from "../pages/manageaccount/ApiAccess";
import SwitchAccountPage from "../pages/switchaccount/Switchaccount";
import SubBidReasearchTool from "../subbid/SubBidReasearchTool";
import ReferralForm from "../pages/Referalprogram/ChangelogPage";
import UserManualPage from "../pages/usermanualpage/Usermanualpage";
import ContactSupportPage from "../pages/contactsupport/ContactSupport";
import AdminPannelPage from "../admin/AdminPannel";
import LogOutPage from "../pages/logout/logoutpage"
import AdminPageData from "../admin/AdminPageData";
import OpenSupportTicketPage from "../pages/contactsupport/Opensupportticket";
import ContactbyskypePage from "../pages/contactsupport/Conntactbyskype";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff, faEnvelopeOpen, faSignal, faMagnifyingGlassDollar, faPlusSquare, faBook, faExchange } from '@fortawesome/free-solid-svg-icons';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';



const appRoutes: RouteType[] = [
  {
    index: true,
    element: <DefaultPage />,
    state: "home"
  },
  {
    path: "/installation",
    element: <InboxPage />,
    state: "Inbox",
    sidebarProps: {
      displayText: (
        <>
          Inbox 
          <span style={{ marginLeft:'7px',color: "#81d34a", fontWeight: "normal" }}>
            (4 Messages)
          </span>
          
        </>
      ), icon: <FontAwesomeIcon
        icon={faEnvelopeOpen}
        style={{
          marginRight: "10px",
          paddingBottom: "1px",
          fontSize: "13px",
          color: "var(--white)", // Adjust the color to your needs
        }}
        aria-hidden="true"
        id="message_disp"
        title="You have 4 notifications"
      />
    }
  },
  {
    path: "/dashboard",
    element: <DashboardPageLayout />,
    state: "Campaigns",
    sidebarProps: {
      displayText: "Campaigns",
      icon: <FontAwesomeIcon
        icon={faPlusSquare}
        style={{
          fontSize: "14px",
          marginRight: "10px",
          paddingTop: "2px",
          color: "var(--white)", // Adjust the color to your needs
        }}
        aria-hidden="true"
        id="collapse_img"
      />

    },
    child: [
      // {
      //   index: true,
      //   element: <DashboardIndex />,
      //   state: "Campaigns.index"
      // },
      {
        path: "/dashboard/default",
        element: <DefaultPage />,
        state: "dashboard.default",
        sidebarProps: {
          displayText: "Manage Campaign"
        },
      },
      {
        path: "/dashboard/CreateCampaign",
        element: <CreateCampaign />,
        state: "Campaigns.CreateCampaign",
        sidebarProps: {
          displayText: "Create New Campaign"
        }
      },
      {
        path: "/dashboard/conversionpage",
        element: <ConversionsUpload />,
        state: "dashboard.conversionspage",
        sidebarProps: {
          displayText: "ConversionUpload"
        }
      },
      {
        path: "/dashboard/log",
        element: <Bidlog />,
        state: "dashboard.bidlog",
        sidebarProps: {
          displayText: "Bid AUtomation Log"
        }
      }
    ]
  },
  {
    path: "/component",
    element: <ComponentPageLayout />,
    state: "component",
    sidebarProps: {
      displayText: "Reporting",
      icon: <AppsOutlinedIcon />
    },
    child: [
      {
        path: "/component/DailyActivity",
        element: <DailyActivityPage />,
        state: "component.DailyActivity",
        sidebarProps: {
          displayText: "Daily Activity"
        },
      },
      {
        path: "/component/Summary",
        element: <SummaryPage />,
        state: "component.Summary",
        sidebarProps: {
          displayText: "Summary"
        }
      },
      {
        path: "/component/Analytics",
        element: <AnalyticsPage />,
        state: "component.Analytics",
        sidebarProps: {
          displayText: "Analytics"
        }
      }
    ]
  },
  {
    path: "/globalpostback",
    element: <GlobalPostbackPage />,
    state: "globalpostback",
    sidebarProps: {
      displayText: "Global Postbacks",
      icon: <AppsOutlinedIcon />
    },
    child: [
      {
        path: "/globalpostback/Managepostback",
        element: <ManagepostbackPage />,
        state: "globalpostback.Managepostback",
        sidebarProps: {
          displayText: "Manage Postbacks"
        },
      },
      {
        path: "/globalpostback/Multisteppage",
        element: <Multisteppage />,
        state: "globalpostback.Multisteppage",
        sidebarProps: {
          displayText: "Multi-Step"
        },
      },
      {
        path: "/globalpostback/Testpostback",
        element: <TestPostbackPage />,
        state: "globalpostback.Testpostback",
        sidebarProps: {
          displayText: "Test Postback"
        },
      },
      {
        path: "/globalpostback/ErrorLog",
        element: <ErrorLogPage />,
        state: "globalpostback.ErrorLog",
        sidebarProps: {
          displayText: "Error Log"
        },
      }
    ]
  },
  {
    path: "/Fundingandpayment",
    element: <FundingandpaymentPage />,
    state: "Fundingandpayment",
    sidebarProps: {
      displayText: "Funding & Payment",
      icon: <AppsOutlinedIcon />
    },
    child: [
      {
        path: "/Fundingandpayment/Addfund",
        element: <AddFundsPage />,
        state: "Fundingandpayment.Addfund",
        sidebarProps: {
          displayText: "Add Fund"
        },
      },
      {
        path: "/Fundingandpayment/AutomaticFunding",
        element: <AutomaticFundingPage />,
        state: "Fundingandpayment.AutomaticFunding",
        sidebarProps: {
          displayText: "AutomaticFunding"
        },
      },
      {
        path: "/Fundingandpayment/ProformaInvoice",
        element: <ProformaInvoicePage />,
        state: "Fundingandpayment.ProformaInvoice",
        sidebarProps: {
          displayText: "Proforma Invoice"
        },
      },
      {
        path: "/Fundingandpayment/TransactionHistory",
        element: <TransactionHistoryPage />,
        state: "Fundingandpayment.TransactionHistory",
        sidebarProps: {
          displayText: "Transaction History"
        },
      },
      {
        path: "/Fundingandpayment/MonthlyInvoices",
        element: <MonthlyInvoicesPage />,
        state: "Fundingandpayment.MonthlyInvoices",
        sidebarProps: {
          displayText: "MonthlyInvoices"
        },
      }
    ]
  },


  // Manage Account
  {
    path: "/manageaccount",
    element: <ManageAccountPage />,
    state: "manageaccount",
    sidebarProps: {
      displayText: "ManageAccount",
      icon: <AppsOutlinedIcon />
    },
    child: [
      {
        path: "/manageaccount/EditProfile",
        element: <EditprofilePage />,
        state: "manageaccount.EditProfile",
        sidebarProps: {
          displayText: "Edit Profile"
        },
      },
      {
        path: "/manageaccount/ChangePassword",
        element: <ChangePasswordPage />,
        state: "manageaccount.ChangePassword",
        sidebarProps: {
          displayText: "Chanage Password"
        },
      },
      {
        path: "/manageaccount/TwoFactorAuth",
        element: <TwoFactorAuthPage />,
        state: "manageaccount.TwoFactorAuth",
        sidebarProps: {
          displayText: "Two Factor Authentication"
        },
      },
      {
        path: "/manageaccount/DomianBlacklist",
        element: <DomianBlacklistPage />,
        state: "manageaccount.DomianBlacklist",
        sidebarProps: {
          displayText: "Domain Black List"
        },
      },
      {
        path: "/manageaccount/IpblackList",
        element: <IpblackListPage />,
        state: "manageaccount.IpblackList",
        sidebarProps: {
          displayText: "Ip BlackList"
        },
      },
      {
        path: "/manageaccount/UserAgentBlacklist",
        element: <UserAgentBlacklistPage />,
        state: "manageaccount.UserAgentBlacklist",
        sidebarProps: {
          displayText: "User Agent Black List"
        },
      },
      {
        path: "/manageaccount/ApiAccess",
        element: <ApiAccessPage />,
        state: "manageaccount.ApiAccess",
        sidebarProps: {
          displayText: "Api Access"
        },
      }
    ]
  },

  //Switch Account 





  //Trafficestimator
  {
    path: "/trafficestimator",
    element: <TrafficEstimatorPage />,
    state: "trafficestimator",
    sidebarProps: {
      displayText: "Traffic Estimator",
      icon: <FontAwesomeIcon
        icon={faSignal}
        style={{
          marginRight: "10px",
          paddingBottom: "1px",
          fontSize: "13px",
          color: "var(--white)", // You can adjust the color to your needs
        }}
        aria-hidden="true"
      />
    }
  },



  //Subbid Reasearcg tool 
  {
    path: "/subbid",
    element: <SubBidReasearchTool />,
    state: "subbid",
    sidebarProps: {
      displayText: "Subid Reasearch Tool",
      icon: <FontAwesomeIcon
        icon={faMagnifyingGlassDollar}
        style={{
          marginRight: "10px",
          paddingBottom: "1px",
          fontSize: "13px",
          color: "var(--white)", // You can adjust the color to your needs
        }}
        aria-hidden="true"
      />
    },

  },


  //Referal Program
  {
    path: "/Referalprogram",
    element: <ReferralForm />,
    state: "Referalprogram",
    sidebarProps: {
      displayText: "Refferal Program",
      icon: <FontAwesomeIcon
        icon={faConnectdevelop}
        style={{
          marginRight: "7px",
          paddingBottom: "1px",
          fontSize: "13px",
          color: "var(--white)", // Adjust the color to your needs
        }}
        aria-hidden="true"
      />
    }
  },

  //UserManual
  {
    path: "/usermanualpage",
    element: <UserManualPage />,
    state: "usermanualpage",
    sidebarProps: {
      displayText: "User Manual",
      icon: <FontAwesomeIcon
        icon={faBook}
        style={{
          marginRight: "10px",
          paddingBottom: "1px",
          fontSize: "13px",
          color: "var(--white)", // Adjust the color to your needs
        }}
        aria-hidden="true"
      />
    }
  },



  //Contact Support  
  {
    path: "/contactsupport",
    element: <ContactSupportPage />,
    state: "contactsupport",
    sidebarProps: {
      displayText: "Contact Support",
      icon: <AppsOutlinedIcon />
    },
    child: [
      {
        path: "/contactsupport/OpenSupportTicketPage",
        element: <OpenSupportTicketPage />,
        state: "contactsupport.Opensupportticket",
        sidebarProps: {
          displayText: "Open SUpport Ticket"
        },
      },
      {
        path: "/contactsupport/ContactbyskypePage",
        element: <ContactbyskypePage />,
        state: "contactsupport.ContactbyskypePage",
        sidebarProps: {
          displayText: "Contact by skype"
        },
      }
    ]
  },


  {
    path: "/dashboard/AdminPage",
    element: <AdminPage />,
    state: "adminPage",
    // sidebarProps: {
    //   displayText: "adminpage",
    //   icon: <FormatListBulletedOutlinedIcon />
    // }
  },
  {
    path: "/admin/AdminPannel",
    element: <AdminPannelPage />,
    state: "AdminPannel",
    // sidebarProps: {
    //   displayText: "adminpage",
    //   icon: <FormatListBulletedOutlinedIcon />
    // }
  }
  ,
  {
    path: "/admin/AdminPageData",
    element: <AdminPageData />,
    state: "AdminPageData",
    // sidebarProps: {
    //   displayText: "adminpage",
    //   icon: <FormatListBulletedOutlinedIcon />
    // }
  }
  ,
  {
    path: "/switchaccount",
    element: <SwitchAccountPage />,
    state: "switchaccount",
    sidebarProps: {
      displayText: "Switch Account",
      icon: <FontAwesomeIcon
        icon={faExchange}
        style={{
          marginRight: "10px",
          paddingBottom: "1px",
          fontSize: "13px",
          color: "var(--white)", // Adjust the color to your needs
        }}
        aria-hidden="true"
      />
    },
  },

  {
    path: "/logout/LogoutPage",
    element: <LogOutPage />,
    state: "LogOutPage",
    sidebarProps: {
      displayText: "Logout",
      icon: <FontAwesomeIcon
        icon={faPowerOff}
        style={{
          marginRight: "10px",
          paddingBottom: "1px",
          fontSize: "13px",
          color: "var(--white)", // Adjust the color to your needs
        }}
        aria-hidden="true"
      />
    }
  }

];

export default appRoutes;
